export const urls = {
  onboarding: () => "/api/client/v1/onboarding/",
  events: () => "/api/client/v1/onboarding/events/",
};

export const keys = {
  all: () => ["onboarding-all"],
  onboarding: () => [keys.all(), "onboarding"],
};
